import React from 'react'

import { FormProvider } from 'react-hook-form'

import Box from 'app/components/base/Box'
import GridList from 'app/components/base/GridList'
import Pagination from 'app/components/base/Pagination'
import Stack from 'app/components/base/Stack'
import ProductCardRenderItem from 'app/features/Store/Products/components/ProductCardRenderItem'
import ProductsEmptyState from 'app/features/Store/Products/components/ProductsEmptyState'
import ProductsSort from 'app/features/Store/Products/components/ProductsSort'

import ProductsFilter from './components/ProductsFilter'
import { useProductView } from './hooks/useProductView'

const ProductsView: RFC = () => {
  const {
    methods,
    userBySlug,
    part_numbers,
    isEmpty,
    listings,
    isPageLoading,
    showPagination,
    setPage,
    pages,
    paginationPage,
    isBusinessUser
  } = useProductView()

  return (
    <FormProvider {...methods}>
      <Stack
        spacing={{ md: 3.5, xs: 0 }}
        direction={{ md: 'row', xs: 'column' }}
        sx={{ minHeight: 600 }}
      >
        {userBySlug?.available_listings && (
          <ProductsFilter
            sx={{ display: { xs: 'none', md: 'flex' } }}
            partNumbers={part_numbers || []}
          />
        )}

        <Stack width="100%">
          <Stack
            direction="row"
            justifyContent={{ md: 'flex-end', xs: 'space-between' }}
          >
            <ProductsFilter
              sx={{ display: { xs: 'flex', md: 'none' } }}
              partNumbers={part_numbers || []}
            />

            <ProductsSort />
          </Stack>

          {isEmpty && (
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <ProductsEmptyState />
            </Box>
          )}

          <GridList
            spacing={{ xs: 1.5, md: 3.75 }}
            columns={{ xs: 2, md: 3, lg: 4 }}
            items={listings}
            renderItem={(item) => (
              <ProductCardRenderItem
                item={item}
                loading={isPageLoading}
                isBusinessUser={isBusinessUser}
              />
            )}
          />
        </Stack>
      </Stack>

      {showPagination && (
        <Stack direction="row" sx={{ justifyContent: 'center', mt: 5 }}>
          <Pagination count={pages} page={paginationPage} onChange={setPage} />
        </Stack>
      )}
    </FormProvider>
  )
}

export default ProductsView
